export function sendToGraceNote(object) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'SEND_TO_GRACE_NOTE_SUBMIT',
                object,
            })
        );
}
export function convertGuidsToEids(guids) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'CONVERT_GUIDS_TO_EIDS',
                guids,
            })
        );
}
export function clearBulkEids() {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'CLEAR_BULK_EIDS',
            })
        );
}
export function clearGraceNoteResponse() {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'CLEAR_GRACE_NOTE_RESPONSE',
            })
        );
}
